import type { InputUnit, PantryRow, PantryUnit } from '../../../types';

const DEFAULT_INPUT: Record<PantryUnit, InputUnit> = { UNIT: 'u', GRAM: 'g', MILLILITRE: 'ml' };

/**
 * The unit a product the trip already counts is typed in. Preselecting it
 * makes the server's UNIT_MISMATCH the rare case, not the usual one.
 */
export function knownInputUnit(products: PantryRow[], name: string): InputUnit | null {
  const known = products.find(p => p.name.toLowerCase() === name.trim().toLowerCase());
  return known ? DEFAULT_INPUT[known.unit] : null;
}

/** A stored base amount, as the user would type it back: 1500 g → "1,5" kg. */
export function asTyped(amount: number, unit: PantryUnit): { amount: string; unit: InputUnit } {
  const [small, big] = unit === 'GRAM' ? ['g', 'kg'] as const : unit === 'MILLILITRE' ? ['ml', 'l'] as const : ['u', 'u'] as const;
  const useBig = small !== big && amount >= 1000;
  const value = useBig ? amount / 1000 : amount;
  return { amount: String(Math.round(value * 100) / 100).replace('.', ','), unit: useBig ? big : small };
}

/** "1,5" → 1.5; blank → 1, the default of a thing you buy or use one of. */
export function parseAmount(value: string): number | null {
  if (!value.trim()) return 1;
  const n = Number(value.replace(',', '.'));
  return n > 0 ? n : null;
}
